<div class="container">
    <div class="row">
        <div class="col-12 py-5">
            <div class="d-flex flex-column align-items-center my-5">
                <h1 class="text-primary pb-2 fs-1 fw-normal">Utilisateur non autorisé</h1>
                <h2 class="fs-2 fw-normal">Vous n'êtes pas autorisé à accéder à cette application.</h2>
                <h3 class="fs-3 fw-normal">Contactez votre administrateur.</h3>
            </div>
        </div>
    </div>
</div>
